import { CaretUp, CaretDown } from '@phosphor-icons/react';

export const SortableHeader = ({ label, sortKey, sortConfig, onSort, className = '' }) => {
  const isActive = sortConfig.key === sortKey;
  const direction = isActive ? sortConfig.direction : null;

  return (
    <th
      className={`px-6 py-4 text-left text-sm font-medium text-[#F8FAFC] uppercase tracking-wider cursor-pointer select-none hover:text-[#2563EB] transition-colors ${className}`}
      onClick={() => onSort(sortKey)}
      data-testid={`sort-${sortKey}`}
    >
      <div className="flex items-center gap-1">
        {label}
        <span className="flex flex-col -space-y-1">
          <CaretUp size={10} weight="bold" className={direction === 'asc' ? 'text-[#2563EB]' : 'text-[#334155]'} />
          <CaretDown size={10} weight="bold" className={direction === 'desc' ? 'text-[#2563EB]' : 'text-[#334155]'} />
        </span>
      </div>
    </th>
  );
};

export const useSort = (defaultKey = 'name', defaultDir = 'asc') => {
  const { useState } = require('react');
  const [sortConfig, setSortConfig] = useState({ key: defaultKey, direction: defaultDir });

  const onSort = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const sortData = (data, getVal) => {
    return [...data].sort((a, b) => {
      const valA = getVal ? getVal(a, sortConfig.key) : a[sortConfig.key];
      const valB = getVal ? getVal(b, sortConfig.key) : b[sortConfig.key];

      if (valA == null && valB == null) return 0;
      if (valA == null) return 1;
      if (valB == null) return -1;

      const strA = typeof valA === 'string' ? valA.toLowerCase() : valA;
      const strB = typeof valB === 'string' ? valB.toLowerCase() : valB;

      if (strA < strB) return sortConfig.direction === 'asc' ? -1 : 1;
      if (strA > strB) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  return { sortConfig, onSort, sortData };
};
